import { Gastos, Order, useGetGastosListLazyQuery } from "src/gql/schema"
import { RoleNames } from "src/shared/hooks/useAuth"
import { getFilterDate } from "../GastosList.helpers"
import useGetCurrentDate from "src/shared/hooks/useGetCurrentDate"
import { useEffect, useRef, useState } from "react"
import { useDate } from "src/shared/hooks/useDate"
import { useProfile } from "src/shared/hooks/useProfile"
import { useTurnoActual } from "src/pages/home/room-detail/hooks/turnos"

const useGetGastosList = ({ date = "", year = "", page = 1, categoryId = "", subCategoryId = "", search = "" }) => {
    const [getGastosList] = useGetGastosListLazyQuery()
    const { currentDate } = useGetCurrentDate()
    const turnoActual = useTurnoActual()
    const { localDateToUTCString } = useDate()
    const { hotel_id, rolName } = useProfile()
    const profile = rolName
    const [gastos, setGastos] = useState<Gastos[]>([])
    const [isLoading, setisLoading] = useState(false)
    const [totalPages, settotalPages] = useState(1)

    const getData = () => {
        const filterDate = getFilterDate(year, date, currentDate)
        const [todayMonth, today, todayYear] = [
            currentDate.getMonth(),
            currentDate.getDate(),
            currentDate.getFullYear(),
        ]
        const newToday = new Date(todayYear, todayMonth, today)

        setisLoading(true)

        getGastosList({
            variables: {
                pagination_options: {
                    order: Order.Asc,
                    page,
                    take: 12
                },
                rol_name: profile === RoleNames.recepcionista ? RoleNames.recepcionista : null,
                search_text: search ? search : null,
                categoria_id: categoryId || null,
                hotel_id,
                caja_chica: profile === RoleNames.recepcionista ? true : null,
                subcategoria_id: subCategoryId || null,
                fecha_gasto:
                    profile === RoleNames.recepcionista
                        ? { fecha_final: filterDate.end, fecha_inicial: localDateToUTCString(newToday) }
                        : date || year
                            ? {
                                fecha_final:
                                    currentDate.getDate() === new Date(filterDate.end).getDate()
                                        ? currentDate
                                        : filterDate.end,
                                fecha_inicial: filterDate.start,
                            }
                            : null,
            },
        })
            .then(({ data }) => {
                if (data?.gastos) {
                    setGastos(data.gastos.gastos as Gastos[])
                    settotalPages(data.gastos.paginacion.total_paginas)
                } else {
                    setGastos([])
                }
            })
            .catch((e) => {
                setGastos([])
                console.log(e)
            })
            .finally(() => {
                setisLoading(false)
            })
    }


    useEffect(() => {
        if (search.length) {
            return
        }
        getData()
        
    }, [date, year, categoryId, subCategoryId, turnoActual, page, search])

    const timerRef = useRef<NodeJS.Timer>()

    useEffect(() => {
        if(!search.length) {
            return
        }
        clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => {
            getData()
        }, 300)
    }, [search])

    const refetch = () => {
        getData()
    }


    return { gastos, isLoading, totalPages, refetch }
}

export default useGetGastosList